import { Icon } from '@iconify/react';

import {
  Dialog,
  Button,
  Tooltip,
  IconButton,
  DialogTitle,
  DialogContent
} from '@mui/material';

import closeOutline from '@iconify-icons/eva/close-outline';

interface DeleteModalProps {
  open?: boolean;
  setModal: (open: boolean) => void;
  item: { id: string } | null;
  confirmDelete: (id: string) => void;
  deleteButtonPressed: boolean;
  handleDeleteButtonPressed: (pressed: boolean) => void;
}

const DeleteModal = ({
  open = false,
  setModal,
  item = null,
  confirmDelete,
  deleteButtonPressed,
  handleDeleteButtonPressed
}: DeleteModalProps) => {
  return (
    <Dialog open={open} onClose={() => setModal(false)}>
      <DialogTitle
        style={{
          display: 'flex',
          alignItems: 'center',
          background: '#fafafa',
          padding: '10px 15px 10px 30px',
          justifyContent: 'space-between'
        }}
      >
        <h3>{'Confirm To Delete'}</h3>
        <Tooltip arrow title="Close">
          <IconButton onClick={() => setModal(!open)} size="large">
            <Icon icon={closeOutline} />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <DialogContent>
        {'Are you sure you want to delete this item?'}
      </DialogContent>
      <div
        style={{
          padding: '10px',
          display: 'flex',
          justifyContent: 'flex-end',
          background: '#fafafa',
          width: '100%'
        }}
      >
        <Button
          onClick={() => {
            handleDeleteButtonPressed(true);
            if (item) confirmDelete(item.id);
          }}
          variant="contained"
          disabled={deleteButtonPressed}
        >
          {deleteButtonPressed ? 'Deleting...' : 'Confirm'}
        </Button>
      </div>
    </Dialog>
  );
};

export default DeleteModal;
